import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BasicInputTypeEnum } from 'src/shared/enums/basic-input-type.enum';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { IBasicInputConfig } from '../../../interfaces/basic-input-config.interface';

@Component({
    selector: 'app-sensitive-input',
    templateUrl: './sensitive-input.component.html',
    styleUrls: ['./sensitive-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SensitiveInputComponent,
            multi: true,
        },
    ],
})
export class SensitiveInputComponent extends FormControlComponent implements OnInit {
    @Input() public inputConfig: IBasicInputConfig;
    @Input() public isValid = true;
    @Input() public classes = '';
    @Input() public icons: string;
    @Input() public readOnly = false;
    @Input() public maxLength = 2500;
    @Input() public isEdit: boolean;

    @Output() public isEditChange = new EventEmitter<boolean>();

    public placeholder: string;
    public inputId: string;
    public type: BasicInputTypeEnum;

    public inputControl = new FormControl();

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.placeholder = this.inputConfig.placeholder;
        this.inputId = this.inputConfig.inputId;
        this.type = this.inputConfig.type;
        this.icons = this.icons && this.icons.length > 0 ? 'input-icon icon ' + this.icons : '';
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.inputControl.patchValue(obj);
    }

    public onInput(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.inputControl.value;

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public enableEdit(): void {
        this.isEdit = true;
        this.isEditChange.emit(this.isEdit);
    }
}
